<div class="tw-relative" (smlClickOutside)="!isMobile ? closeShareDropdown() : false">

  @if(showShareButton){
  <button [disabled]="((campaigndetails?.accessType === campaignAccessType.Archived || initiativeStatus === campaignAccessType.Archived) && iscalledFromCampaign)" type="button" id="{{ identifierPrefix }}share-dropdown-button" [smlButton]="buttonType" [size]="'sm'"
    [rounded]="'md'" [ngClass]="
    (!isCalledForItem
      ? 'share__share__button !tw-border-none tw-gap-2 !tw-py-0 tw-min-h-11 tw-min-w-11 !tw-duration-0 ' + shareButtonClasses
      :'share__share__button !tw-duration-0 '+ shareButtonClasses)
    + (((campaigndetails?.accessType === campaignAccessType.Archived || initiativeStatus === campaignAccessType.Archived) && iscalledFromCampaign) ? ' max-md:tw-opacity-50 max-md:tw-pointer-events-none' : '')
  " (click)="openShareDropdown()">
    <i-icon [name]="shareIconName" [height]="'tw-h-5'" [width]="'tw-w-5'"></i-icon>
    @if(contentName){
    <span [ngClass]="{'tw-font-bold':contentNameBold}">{{ contentName }}</span>
    }
  </button>
  } @if(showShareButton){
  @if(iscalledFromCampaign && showShareDropdown){
  <sml-dialog #smlDialog [size]="'lg'" [isOpen]="iscalledFromCampaign && showShareDropdown" [isCalledFomCampaignShare]="true"
    (closed)="closeShareDropdown()"
    [bodyClass]="'!tw-bg-white !tw-w-full !tw-max-w-[720px] !tw-h-auto tw-p-0 tablet:!tw-rounded-3xl tw-mx-auto tablet:tw-mx-auto'"
    [customDialogBodySpacing]="'!tw-p-0 !tw-m-0'">
    @if(isCampaign){
    <ng-container *ngTemplateOutlet="default"></ng-container>
    } @else if(isQr){
    <ng-container *ngTemplateOutlet="qrcode"> </ng-container>
    } @else if(isPrivate) {
    <ng-container *ngTemplateOutlet="privateLink"></ng-container>

    }
    @else {
       <ng-container *ngTemplateOutlet="selectCampaign"></ng-container>
    }
  </sml-dialog>
  }
  <ng-template #default>
    <div class="tw-flex tw-flex-col !tw-pt-0">
      <div class="tw-bg-primary-700 tablet:tw-p-[32px] tw-px-[16px] tw-py-[30px] !tw-rounded-t-3xl !tw-rounded-tr-3xl"
        [ngClass]="{'tablet:!tw-rounded-3xl':!isLoggedIn || !isValidCommunityUser()}">
        <div class="!tw-bg-[#106B8E] tw-w-full tw-text-white tw-relative tw-rounded-tl-[13px] tw-rounded-tr-[13px]">
          <div class="tw-flex tw-justify-between tw-pb-[20px]">
            <div>
              &nbsp;
            </div>
            <div class="tw-flex tw-items-center tw-gap-1" *ngIf="isLoggedIn && isValidCommunityUser()">
              <div class="max-md:tw-text-xs tw-font-normal">
                 Your {{isInitiative ? 'Community Initiative' : 'Campaign'}} Status:
              </div>
              <div class="tw-border tw-border-[#4089A5] tw-bg-[#F0F7FB] tw-py-2 max-md:tw-py-1 tw-pl-[10px] tw-pr-2 max-md:tw-pr-[5px] tw-text-sm max-md:tw-font-black tw-font-bold tw-text-[#3C4243] tw-rounded tw-h-[27px] tw-flex tw-items-center tw-gap-[2px]">
                <div>
                  {{ (campaigndetails?.accessType ?? initiativeStatus) === campaignAccessType.Public ? 'Public' : (campaigndetails?.accessType ?? initiativeStatus) === campaignAccessType.Archived ? 'Archived' : 'Private' }}
                </div>
                 <div class="max-md:tw-pb-1"><i-icon [name]="(campaigndetails?.accessType ?? initiativeStatus) === campaignAccessType.Public ? 'eye-o' : (campaigndetails?.accessType ?? initiativeStatus) === campaignAccessType.Archived ? 'archive-tab' : 'lock'" class="!tw-w-[18px] !tw-h-[18px]"></i-icon></div>
              </div> 
            </div>
            <button class="tw-text-white" (click)="closeShareDropdown()" aria-label="Close">
              <i-icon *ngIf="!isMobile" [name]="'close'" class="tw-text-white hover:tw-opacity-80 tw-w-[24px] tw-h-[24px]"></i-icon>
            </button>
          </div>
          <div class="tw-flex tw-justify-center">
            @if(isLoggedIn && !isTokenExpired && isValidCommunityUser()){
            <h2
              class="tw-w-[250px] tablet:tw-w-full tw-text-white tw-text-center tw-font-[Satoshi] tw-text-[18px] tablet:tw-text-[24px] tw-font-bold tw-leading-[32px] tw-not-italic tw-pb-[20px]">
              {{isInitiative ? 'Consistent promotion drives results' : ' The most successful Campaigns are shared often.'}}
             
            </h2>
            }

            @if(!isLoggedIn || !isValidCommunityUser()){
            <div class="tw-flex tw-flex-col">
              <h2
                class="tw-text-white tw-text-center tw-font-[Satoshi] tw-text-[18px] tablet:tw-text-[24px] tw-font-bold tw-leading-[32px] tw-not-italic tablet:tw-w-full tw-w-[345px]">
                Your support means a lot.
              </h2>
              <h2
                class="tw-text-white tw-text-center tw-font-[Satoshi] tw-text-[18px] tablet:tw-text-[24px] tw-font-bold tw-leading-[32px] tw-not-italic tw-pb-[20px] tablet:tw-w-full tw-w-[345px]">
                Help spread the word and inspire more people to join.
              </h2>
            </div>
            }

          </div>
          <p
            class="tw-pb-[10px] tw-text-white tw-font-[Satoshi] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-not-italic tw-capitalize">
            Public Share Link</p>
          <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
            <input type="text"
              class="tablet:tw-w-[540px] tw-w-full tw-p-3 tw-rounded tw-text-[#041519] tw-font-[Satoshi] tw-text-[14px] tw-font-medium tw-leading-[20px] tw-not-italic tw-h-[48px]"
              [value]="isInitiative ? initiativeUrl : campaignUrl" readonly />
            <button
              class="tw-font-satoshi tw-font-bold tw-w-[100px] tw-text-sm tw-h-[52px] tw-bg-[#F0F7FB] tw-text-primary-700 tw-px-4 tw-py-2 tw-rounded"
              (click)="handleCopyUrl()">
              Copy
            </button>
          </div>

          <div class="tw-flex tw-flex-row tw-gap-4 tw-mt-5 tw-justify-center">
            <i-icon [name]="'facebook-blue-share'"
              class="tw-cursor-pointer tw-w-[27.5px] tw-h-[27.5px] tw-text-[#FC9F5B]" (click)="OpenFacebook()"></i-icon>
            <i-icon [name]="'linkedin-share-blue'"
              class="tw-cursor-pointer tw-w-[27.5px] tw-h-[27.5px] tw-text-[#FC9F5B]" (click)="OpenLinkedin()"></i-icon>
            <i-icon [name]="'twitter-share-blue'"
              class="tw-cursor-pointer tw-w-[27.5px] tw-h-[27.5px] tw-text-[#FC9F5B]" (click)="OpenTwitter()"></i-icon>
            <i-icon [name]="'mail-share-blue'" class="tw-cursor-pointer tw-w-[27.5px] tw-h-[27.5px] tw-text-[#FC9F5B]"
              (click)="OpenMailto()"></i-icon>
          </div>
        </div>
      </div>

      <div *ngIf="isLoggedIn && !isTokenExpired && isValidCommunityUser()"
        class="tw-bg-white tablet:tw-pb-8 tw-text-black tw-w-full tablet:tw-p-8 tw-p-4 tw-flex tw-flex-col tw-gap-4 tw-border-t tw-border-gray-300 tablet:tw-rounded-b-3xl" [ngStyle]="isMobile ? {'padding-bottom': calculateDynamicPaddingBottom()} : {}">
        <div class="tw-border tw-rounded-lg tw-px-6 tw-py-3 tw-flex tw-flex-col tw-gap-2 tw-relative"
          (click)="showQrCode()">
          <div class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
            <i-icon [name]="'lens-blue'" class="!tw-w-4 !tw-h-4"></i-icon>
            <h3
              class="tw-text-[#041519] tw-font-[Satoshi] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-not-italic tw-capitalize tw-flex tw-items-center tw-gap-2">
              <div>
               {{isInitiative ? 'Community Initiative' : 'Campaign'}} QR Code
              </div>
               <div class="tw-mr-2 tw-flex tw-items-center tw-rounded-lg tw-text-xs tw-font-bold tw-bg-[#F0F7FB] tw-py-[1px] tw-pl-2 tw-pr-1 tw-gap-[2px] tw-text-[#3C4243]" *ngIf="!isMobile">
                <div>
                  Public {{isInitiative ? 'Community Initiative' : 'Campaign'}} Only
                </div>
                <div>
                  <i-icon [name]="'public-eye'" class="!tw-w-[18px] !tw-h-[18px]"></i-icon>
                </div>
              </div>
            </h3>
          </div>
           <div class="tw-mr-2 tw-flex tw-items-center tw-rounded-[4px] tw-text-xs tw-font-bold tw-bg-[#F0F7FB] tw-py-[1px] tw-pl-2 tw-pr-1 tw-gap-[2px] tw-max-w-fit tw-text-[#3C4243]" *ngIf="isMobile">
                <div>
                  Public {{isInitiative ? 'Community Initiative' : 'Campaign'}} Only
                </div>
                <div>
                  <i-icon [name]="'public-eye'" class="!tw-w-[18px] !tw-h-[18px]"></i-icon>
                </div>
            </div>
          <div class="tw-flex tw-justify-between tw-items-center tw-cursor-pointer">
            <p
              class="tw-text-[#828485] tw-font-[Satoshi] tw-text-[14px] tw-font-medium tw-leading-[20px] tw-not-italic tw-max-w-[295px] tablet:tw-max-w-full">
              Add this code to flyers, brochures, and posters so participants can Scan-to-Participate.
            </p>
            <i-icon [name]="'angle-right'"
              class="!tw-w-4 !tw-h-4 tw-absolute tablet:tw-bottom-[23px] tw-bottom-[37px] tw-right-[10px] tablet:tw-right-[17px]"></i-icon>
          </div>
        </div>

        <div class="tw-border tw-rounded-lg tw-px-6 tw-py-3 tw-flex tw-flex-col tw-gap-2 tw-cursor-pointer tw-relative"
          (click)="showselectedCampaign()">
          <div class="tw-flex tw-items-center tw-gap-2">
            <i-icon [name]="'embed-blue'" class="!tw-w-4 !tw-h-4"></i-icon>
             <h3
              class="tw-text-[#041519] tw-font-[Satoshi] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-not-italic tw-capitalize tw-flex tw-items-center tw-gap-2">
              <div>
               Embed on your Website
              </div>
               <div class="tw-mr-2 tw-flex tw-items-center tw-rounded-lg tw-text-xs tw-font-bold tw-bg-[#F0F7FB] tw-py-[1px] tw-pl-2 tw-pr-1 tw-gap-[2px] tw-text-[#3C4243]" *ngIf="!isMobile">
                <div> 
                  Public {{isInitiative ? 'Community Initiative' : 'Campaign'}} Only
                </div>
                <div>
                  <i-icon [name]="'public-eye'" class="!tw-w-[18px] !tw-h-[18px]"></i-icon>
                </div>
              </div>
            </h3>
          </div>
           <div class="tw-mr-2 tw-flex tw-items-center tw-rounded-lg tw-text-xs tw-font-bold tw-bg-[#F0F7FB] tw-py-[1px] tw-pl-2 tw-pr-1 tw-gap-[2px] tw-max-w-fit tw-text-[#3C4243]" *ngIf="isMobile">
                <div> 
                  Public {{isInitiative ? 'Community Initiative' : 'Campaign'}} Only
                </div>
                <div>
                  <i-icon [name]="'public-eye'" class="!tw-w-[18px] !tw-h-[18px]"></i-icon>
                </div>
              </div>
          <div class="tw-flex tw-justify-between tw-items-center">
            <p
              class="tw-text-[#828485] tw-font-[Satoshi] tw-text-[14px] tw-font-medium tw-leading-[20px] tw-not-italic">
              Add this {{isInitiative ? 'community initiative' : 'campaign'}} to your website so participants can explore and participate effortlessly.
            </p>
            <i-icon [name]="'angle-right'"
              class="!tw-w-4 !tw-h-4 tw-absolute tablet:tw-bottom-[23px] tw-bottom-[37px] tw-right-[10px] tablet:tw-right-[17px]"></i-icon>
          </div>
        </div>
         <div class="tw-border tw-rounded-lg tw-px-6 tw-py-3 tw-flex tw-flex-col tw-gap-2 tw-cursor-pointer tw-relative"
          (click)="showPrivateLink()" *ngIf="this.campaigndetails?.accessType === campaignAccessType['Private'] && !isInitiative">
          <div class="tw-flex tw-items-center tw-gap-2">
            <i-icon [name]="'link-share-blue'" class="!tw-w-4 !tw-h-4"></i-icon>
              <h3
              class="tw-text-[#041519] tw-font-[Satoshi] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-not-italic tw-capitalize tw-flex tw-items-center tw-gap-2">
              <div>
               Private Share Link
              </div>
               <div class="tw-mr-2 tw-flex tw-items-center tw-rounded-lg tw-text-xs tw-font-bold tw-bg-[#F0F7FB] tw-py-[1px] tw-pl-2 tw-pr-1 tw-gap-[2px] tw-text-[#3C4243]" *ngIf="!isMobile">
                <div>
                  Private Campaigns Only
                </div>
                <div>
                  <i-icon [name]="'lock'" class="!tw-w-[18px] !tw-h-[18px]"></i-icon>
                </div>
              </div>
            </h3>
          </div>
          <div class="tw-mr-2 tw-flex tw-items-center tw-rounded-lg tw-text-xs tw-font-bold tw-bg-[#F0F7FB] tw-py-[1px] tw-pl-2 tw-pr-1 tw-gap-[2px] tw-max-w-fit tw-text-[#3C4243]" *ngIf="isMobile">
                <div>
                  Private Campaigns Only
                </div>
                <div>
                  <i-icon [name]="'lock'" class="!tw-w-[18px] !tw-h-[18px]"></i-icon>
                </div>
              </div>
          <div class="tw-flex tw-justify-between tw-items-center">
            <p
              class="tw-text-[#828485] tw-font-[Satoshi] tw-text-[14px] tw-font-medium tw-leading-[20px] tw-not-itali tablet:tw-max-w-[90%]">
              Create a private shareable link to allow only invited community members with this link to access and participate in your campaign.
            </p>
            <i-icon [name]="'angle-right'"
              class="!tw-w-4 !tw-h-4 tw-absolute tablet:tw-bottom-[23px] tw-bottom-[37px] tw-right-[10px] tablet:tw-right-[17px]"></i-icon>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #qrcode>
    <div class="tw-flex tw-flex-col tw-h-full tablet:tw-rounded-3xl tw-overflow-hidden">
      <!-- Header -->
      <div class="tw-bg-[#106B8E] tw-w-full tablet:tw-p-8 tw-p-[30px] tw-text-white tw-relative tw-rounded-t-3xl">
        <div class="tw-flex tw-justify-end">
          <button class="tw-text-white" (click)="closeShareDropdown()" aria-label="Close">
            <i-icon [name]="'close'"
              class="tw-text-white hover:tw-opacity-80 tw-hidden md:tw-block tw-w-[24px] tw-h-[24px]"></i-icon>
          </button>
        </div>
        <h2
          class="tw-text-white tw-text-center tw-font-[Satoshi] tablet:tw-text-[24px] tw-text-[18px] tw-font-bold tw-leading-[32px] tw-not-italic">
          Share your {{isInitiative ? 'Community Initiative' : 'Campaign'}} @if(isInitiative){<br/>}QR Code
        </h2>
      </div>

      <!-- Content -->
      <div class="tw-flex tw-flex-col tw-gap-5 tablet:tw-pb-8 tw-p-4 tablet:tw-p-8 tw-bg-white tw-flex-1" [ngStyle]="isMobile ? {'padding-bottom': calculateDynamicPaddingBottom()} : {}">
        <div class="tw-flex tw-flex-col tw-gap-2 tw-border-none tw-bg-[#F0F7FB] tw-px-6 tw-py-3 tw-rounded-[8px]">
          <div class="tw-flex tw-items-center tw-gap-2">
            <i-icon [name]="'lens-blue'" class="!tw-w-4 !tw-h-4"></i-icon>
            <span
              class="tw-text-[#041519] tw-font-[Satoshi] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-not-italic tw-capitalize">
              {{isInitiative ? 'Community Initiative' : 'Campaign'}} QR Code
            </span>
          </div>
          <span>
            <p
              class="tw-text-[#828485] tw-font-[Satoshi] tw-text-[14px] tw-font-medium tw-leading-[20px] tw-not-italic">
              Your participants can Scan-to-Participate.
            </p>
            <p
              class="tw-text-[#828485] tw-font-[Satoshi] tw-text-[14px] tw-font-medium tw-leading-[20px] tw-not-italic">
              Include in your promotional material, like flyers, brochures, and posters.
            </p>
          </span>
        </div>

        <div class="tw-flex tw-justify-center">
          <img [src]="qrCodeImageUrl" alt="QR Code" class="tw-w-[170px] tw-h-[170px] tw-rounded-lg tw-object-contain" />
        </div>

        <div class="tw-flex tw-flex-row tw-gap-4 tw-w-full tw-justify-center">
          <button smlButton="secondary" [size]="'sm'" [rounded]="'lg'" (click)="copyImage()"
            class="tw-gap-2 tw-w-[150px] tw-h-[40px]">
            <i-icon [name]="'copy'" class="tw-w-5 tw-h-5"></i-icon>
            Copy PNG
          </button>
          <button smlButton="primary" [size]="'sm'" [rounded]="'lg'" (click)="downloadImage()"
            class="tw-gap-2 tw-w-[150px] tw-h-[40px]">
            <i-icon [name]="'download'" class="tw-w-5 tw-h-5"></i-icon>
            Download
          </button>
        </div>
      </div>

      <!-- Footer -->
      <div class="tw-bg-white tablet:tw-rounded-b-3xl tw-px-8 tw-pb-4 tw-pt-0">
        <button smlButton="link" [size]="'md'" [rounded]="'lg'" (click)="showCampaign()" class="tw-pt-0">
          <i-icon [name]="'arrow-back'" class="!tw-w-5 !tw-h-5 !tw-m-[5px]"></i-icon>
          Back
        </button>
      </div>
    </div>
  </ng-template>
    <ng-template #privateLink>
    <div class="tw-flex tw-flex-col tw-h-full tablet:tw-rounded-3xl tw-overflow-hidden">
      <!-- Header -->
      <div class="tw-bg-[#106B8E] tw-w-full tablet:tw-p-8 tw-p-[30px] tw-text-white tw-relative tw-rounded-t-3xl">
        <div class="tw-flex tw-justify-end">
          <button class="tw-text-white" (click)="closeShareDropdown()" aria-label="Close">
            <i-icon [name]="'close'"
              class="tw-text-white hover:tw-opacity-80 tw-hidden md:tw-block tw-w-[24px] tw-h-[24px]"></i-icon>
          </button>
        </div>
        <h2
          class="tw-text-white tw-text-center tw-font-[Satoshi] tablet:tw-text-[24px] tw-text-[18px] tw-font-bold tw-leading-[32px] tw-not-italic">
          Share your Private Link
        </h2>
      </div>

      <!-- Content -->
      <div class="tw-flex tw-flex-col tw-gap-5 tablet:tw-pb-8 tw-p-4 tablet:tw-p-8 tw-bg-white tw-flex-1" [ngStyle]="isMobile ? {'padding-bottom': calculateDynamicPaddingBottom()} : {}">
        <div class="tw-flex tw-flex-col tw-gap-2 tw-border-none tw-bg-[#F0F7FB] tw-px-6 tw-py-3 tw-rounded-[8px]">
          <div class="tw-flex tw-items-center tw-gap-2">
            <i-icon [name]="'link-share-blue'" class="!tw-w-4 !tw-h-4"></i-icon>
            <span
              class="tw-text-[#041519] tw-font-[Satoshi] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-not-italic tw-capitalize">
              Private Share Link: <span class="tw-text-[#828485] tw-font-medium">Private Campaigns Only</span>
            </span>
          </div>
          <div class="tw-text-[#828485] tw-font-medium tw-text-sm">
            Give select participants access to your private campaign through a shareable link. Anyone with the link can view, engage, and participate, while the campaign remains hidden on your public profile.
          </div>
        </div>
         <div class="tw-flex tw-flex-col tw-gap-2">
          <div class="tw-flex tw-w-full">
            <p
              class="tw-font-bold tw-text-[14px] tw-leading-[24px] !tw-text-primary-700 tw-font-satoshi">
             Copy and share this Private Campaign link
            </p>
          </div>

            <div class="tw-flex tw-flex-row tw-items-center tw-gap-4">
            <input type="text"
              class="tablet:tw-w-[540px] tw-w-full tw-p-3 tw-rounded tw-text-[#041519] tw-font-[Satoshi] tw-text-[14px] tw-font-medium tw-leading-[20px] tw-not-italic tw-h-[48px] tw-border"
              [value]="campaignPrivateUrl" readonly />
            <button
              class="tw-font-satoshi tw-w-[100px] tw-h-[52px] tw-bg-[#F0F7FB] tw-text-primary-700 tw-font-bold tw-px-4 tw-py-2 tw-rounded"
              (click)="handleCopyPrivateUrl()">
              Copy
            </button>
          </div>
        </div>
       
      </div>

      <!-- Footer -->
      <div class="tw-bg-white tablet:tw-rounded-b-3xl tw-px-8 tw-pb-4 tw-pt-0">
        <button smlButton="link" [size]="'md'" [rounded]="'lg'" (click)="showCampaign()" class="tw-pt-0">
          <i-icon [name]="'arrow-back'" class="!tw-w-5 !tw-h-5 !tw-m-[5px]"></i-icon>
          Back
        </button>
      </div>
    </div>
  </ng-template>

  <ng-template #selectCampaign>
    <div class="tw-flex tw-flex-col tw-h-full tablet:tw-rounded-3xl tw-overflow-hidden">
      <div class="tw-bg-[#106B8E] tw-w-full tw-p-[30px] tablet:tw-p-8 tw-text-white tw-relative tw-rounded-t-3xl">
        <div class="tw-flex tw-justify-end">
          <button class="tw-text-white" (click)="closeShareDropdown()" aria-label="Close">
            <i-icon [name]="'close'"
              class="tw-text-white hover:tw-opacity-80 tw-hidden md:tw-block tw-w-[24px] tw-h-[24px]"></i-icon>
          </button>
        </div>
        <h2
          class="tw-text-white tw-text-center tw-font-[Satoshi] tablet:tw-text-[24px] tw-text-[18px] tw-font-bold tw-leading-[32px] tw-not-italic">
          {{isInitiative ? 'Embed your Initiative' :' Select an embed option'}}
        </h2>
      </div>

      <div
        class="tw-flex tw-flex-col tw-gap-5 tw-pb-[75px] tablet:tw-pb-8 tw-w-full tablet:tw-p-8 tw-p-4 tablet:tw-rounded-3xl">
        <div class="tw-flex tw-gap-4 tw-justify-center" *ngIf="!isInitiative">
          <button [smlButton]="!isMapButtonSelected ? 'default-alt' : 'default'" [size]="'sm'" [rounded]="'lg'"
            [ngClass]="{
              '!tw-bg-[#F0F7FB] !tw-border-primary-700': !isMapButtonSelected,
              '!tw-bg-white': isMapButtonSelected
            }" class="tw-flex tw-items-center tw-gap-x-2 !tw-text-primary-700" (click)="onFullCampaignClick()">
            <i-icon [name]="'bell'" class="tw-w-5 tw-h-5 tw-text-primary-700"></i-icon>
            Full {{isInitiative ? 'Community Initiative' : 'Campaign'}}
          </button>
          @if(isMapViewEnabled){
          <button type="button" [smlButton]="isMapButtonSelected ? 'default-alt' : 'default'" [size]="'sm'"
            [rounded]="'lg'" [ngClass]="{
              '!tw-bg-[#F0F7FB] !tw-border-primary-700': isMapButtonSelected,
              '!tw-bg-white': !isMapButtonSelected
            }" class="tw-flex tw-items-center tw-gap-x-2 !tw-text-primary-700" [disabled]="!isMapViewEnabled"
            [smlTooltip]="!isMapViewEnabled ? 'Map view is disabled for this Campaign. Kindly ensure it is enabled before embedding the Map View.' : ''"
            [tooltipDisabled]="isMapViewEnabled" [placement]="'right'" mode=always (click)="onMapClick()">
            <i-icon [name]="'map-o'" class="tw-w-5 tw-h-5 tw-text-primary-700"></i-icon>
            Campaign Map
          </button>
          }
        </div>

        <div class="tw-flex tw-flex-col tw-gap-2 tw-border tw-rounded-lg tw-bg-[#F0F7FB] tw-px-6 tw-py-3">
          <div class="tw-flex tw-items-center tw-gap-2">
            <i-icon [name]="'embed-blue'" class="!tw-w-4 !tw-h-4"></i-icon>
            <h3 class="tablet:tw-text-base tw-text-[14px] tw-font-bold tw-font-['Satoshi']">
              {{
              !isMapButtonSelected
              ? 'Embed Full ' + (isInitiative ? 'Community Initiative' : 'Campaign') + ' directly on your website'
              : 'Embed the ' + (isInitiative ? 'Community Initiative' : 'Campaign') + ' Map directly on your website'
              }}
            </h3>
          </div>
          <p class="tw-text-[#828485] tw-font-[Satoshi] tw-text-[14px] tw-font-medium tw-leading-[20px] tw-not-italic">
            {{ isInitiative ? initiativeText : (!isMapButtonSelected ? fullCampaignText : campaignMapText) }}
          </p>
        </div>

        <div class="tw-flex tw-flex-col tw-gap-2">
          <div class="tw-flex tw-w-full tw-justify-center">
            <p
              class="tw-font-bold tablet:tw-text-[16px] tw-text-[14px] tw-leading-[24px] !tw-text-primary-700 tw-font-satoshi">
              Add this code to an HTML section on your website
            </p>
          </div>

          <div class="tw-flex tw-flex-row tw-gap-2 tw-items-center">
            <input type="text" class="tw-flex-1 tw-p-2 tw-rounded tw-text-black tw-w-full tw-border"
              [value]="isInitiative?initiativeIframeHtml: iFramehtml" readonly (copy)="!isPublic && $event.preventDefault()"
              (cut)="!isPublic && $event.preventDefault()" (paste)="!isPublic && $event.preventDefault()"
              (contextmenu)="!isPublic && $event.preventDefault()" />
            <button
              class="tw-font-satoshi tw-bg-[#F0F7FB] tw-text-primary-700 tw-font-bold tw-px-4 tw-py-2 tw-rounded disabled:tw-bg-gray-400 disabled:tw-text-gray-600 disabled:tw-cursor-not-allowed"
              [disabled]="!isPublic || (!isMapViewEnabled && isMapButtonSelected)"
              (click)="isPublic && copyEmbeddedCode() " [tooltipDisabled]="isPublic"
              [smlTooltip]="!isPublic?'You can only embed a Public ' + (isInitiative ? 'Initiative' : 'Campaign') + '. Post your ' + (isInitiative ? 'Initiative' : 'Campaign') + ', and come back to copy your Embed Code!':''"
              [placement]="'bottom'" mode=always>
              Embed
            </button>
          </div>
        </div>

        <div class="tw-flex tw-flex-col tw-items-center tw-gap-[5px] tw-px-5 tablet:tw-pt-4 tw-pt-0 tw-pb-2 tw-w-full">
          <h3 class="tw-text-[14px] tw-font-bold tw-text-[#1A1C1E] tw-text-center">
            Simple steps to embed
          </h3>

          <p
            class="tw-text-[#828485] tw-text-center tw-font-[Satoshi] tw-text-[14px] tw-font-bold tw-leading-[20px] tw-not-italic">
            1. Add code to an HTML section on your website<br />
            2. Adjust sizing as needed
          </p>

          <div class="tw-flex tw-items-center tw-w-full tw-justify-center">
            <button smlButton="link" [size]="'md'" [rounded]="'lg'" (click)="showCampaign()"
              class="tw-items-center !tw-pl-0 !tw-hidden tablet:!tw-flex">
              <i-icon [name]="'arrow-back'" class="!tw-w-5 !tw-h-5 !tw-m-[5px]"></i-icon>
              Back
            </button>

            <div class="tw-flex-1 tw-flex tw-justify-center tablet:tw-pr-[88px]">
              <p class="tw-text-sm tw-font-semibold tw-text-[#828485]">
                Need help?
              </p>
              <a href="https://seemylegacy.com/pages/submit-a-support-form" target="_blank"
                class="tw-ml-2 tw-items-center tw-text-sm tw-font-semibold">
                <span class="tw-text-sm tw-font-semibold tw-text-primary-700">Contact Support!</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="tw-flex tablet:tw-rounded-3xl">
        <button smlButton="link" [size]="'md'" [rounded]="'lg'" (click)="showCampaign()"
          class="tw-items-center !tw-pl-[45px] !tw-pb-[40px] !tw-pt-0 tw-flex tablet:!tw-hidden">
          <i-icon [name]="'arrow-back'" class="!tw-w-5 !tw-h-5 !tw-m-[5px]"></i-icon>
          Back
        </button>
      </div>
    </div>
  </ng-template>

  @if(!iscalledFromCampaign && showShareDropdown){
  <div class="share__dropdown__container {{
      isMobile ? 'share__dropdown__container--share' : ''
    }}" [ngClass]="{ 'tablet:!tw-left-[-80px]': !isLoggedIn }">
    <div [@slideUp]="
        isMobile
          ? { value: 'in', params: { startY: '100%', duration: '600ms' } }
          : { value: 'off' }
      ">
      <button type="button" [smlButton]="'default'" [size]="'sm'" [rounded]="'full'"
        class="md:!tw-hidden tw-absolute tw-right-3 tw-top-0 -tw-translate-y-12 !tw-p-0 tw-h-10 tw-w-10"
        (click)="closeShareDropdown()">
        <i-icon [name]="'x-mark'" class="tw-h-3 tw-w-3"></i-icon>
      </button>
      <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full tw-text-left {{
          isMobile ? 'share__dropdown__container--share-inner' : ''
        }}">
        @if(isMobile){
        <div class="tw-text-center tw-text-primary-950 tw-text-xl tw-font-bold tw-leading-7">
          Share
        </div>
        }
        <button type="button" id="{{ identifierPrefix }}copy-button" class="share__dropdown__item"
          (click)="handleShare('copy')">
          <i-icon [name]="'copy'" [height]="'tw-h-5'" [width]="'tw-w-5'"></i-icon>
          <span>Copy URL</span>
        </button>
        <button type="button" id="{{ identifierPrefix }}qr-button" class="share__dropdown__item" (click)="openDrawer()">
          <i-icon [name]="'qr'" [height]="'tw-h-5'" [width]="'tw-w-5'"></i-icon>
          <span>Generate QR Code</span>
        </button>
        <button type="button" id="{{ identifierPrefix }}qr-button" class="share__dropdown__item"
          (click)="OpenFacebook()">
          <i-icon [name]="'facebook-circle-o'" [height]="'tw-h-5'" [width]="'tw-w-5'"></i-icon>
          <span>Share on Facebook</span>
        </button>
        <button type="button" id="{{ identifierPrefix }}qr-button" class="share__dropdown__item"
          (click)="OpenLinkedin()">
          <i-icon [name]="'linkedin-circle-o'" [height]="'tw-h-5'" [width]="'tw-w-5'"></i-icon>
          <span>Share on LinkedIn</span>
        </button>
        <button type="button" id="{{ identifierPrefix }}qr-button" class="share__dropdown__item"
          (click)="OpenTwitter()">
          <i-icon [name]="'twitter-circle-o'" [height]="'tw-h-5'" [width]="'tw-w-5'"></i-icon>
          <span>Share on X</span>
        </button>
        <button type="button" id="{{ identifierPrefix }}qr-button" class="share__dropdown__item" (click)="OpenMailto()">
          <i-icon [name]="'mail-circle-o'" [height]="'tw-h-5'" [width]="'tw-w-5'"></i-icon>
          <span>Share on Email</span>
        </button>
      </div>
      @if(isMobile){
      <div class="tw-block tw-p-5 tw-border-t tw-border-grey-100 tw-bg-white tw-text-center">
        <button type="button" class="tw-text-primary-700 tw-text-base tw-font-bold" (click)="closeShareDropdown()">
          Close
        </button>
      </div>
      }
    </div>
  </div>
  }}
</div>